import React from 'react';
import ReactDOM from 'react-dom';
import "./assets/css/main.scss";
import './assets/fonts/icomoon/style.css'
import reportWebVitals from './reportWebVitals';
import {Amplify} from 'aws-amplify';
import { ToastContainer } from 'react-toastify';
import { ENVIRONMENT, API_URL } from './common/constants';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';

const config = {
  aws_cognito_region: process.env.REACT_APP_AWS_REGION,
  aws_user_pools_id:  process.env.REACT_APP_AWS_COGNITO_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  oauth: {},
};



Amplify.configure(config);
Amplify.configure({
  API: {
    endpoints: [
      {
        name: ENVIRONMENT,
        endpoint: API_URL,
      },
    ],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <>
      <App />
      <ToastContainer limit={1} theme={"colored"}/>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
